<script>
    import {
        VpChevronBackwardIcon,
        VpCloseIcon,
    } from '@decathlon-experience/icons/svelte';

    import cn from '$common/utils/cn';
    import { FilterType } from '$saga/views/Search/types';
    import SelectFilter from '$saga/views/Search/Filters/SelectFilter.svelte';
    import PaxFilter from '$saga/views/Search/Filters/PaxFilter.svelte';
    import CalendarFilter from '$saga/views/Search/Filters/CalendarFilter.svelte';
    import FiltersSelection from '$saga/views/Search/Filters/FiltersSelection.svelte';
    import { filtersContext } from '$saga/views/Search/store';

    export let selectedFilterType,
        handleSelectedFilter,
        menuTitle,
        title,
        close,
        resetView,
        handleFormSubmissionAnalytics;

    let selectedFilterComponentRef;

    // method called by parent when melt-ui dialog is closed
    export const validateSelectionOnOutsideClick = () => {
        selectedFilterComponentRef?.validateSelection();
        resetView();
    };
</script>

<div
    class="sticky top-0 z-50 mx-m flex min-h-[65px] items-center justify-between border-b border-solid border-border-quiet bg-white py-m desktop:mx-3xl"
>
    {#if selectedFilterType !== FilterType.SELECTION}
        <button on:click={() => handleSelectedFilter(FilterType.SELECTION)}>
            <span class="size-xl text-content-neutral">
                <VpChevronBackwardIcon />
            </span>
        </button>
    {/if}
    <h2 class={cn('text-[22px] font-semibold')} {...$title} use:title>
        {menuTitle}
    </h2>
    <button {...$close} use:close aria-label="Close">
        <VpCloseIcon class="size-xl" />
    </button>
</div>

<section class="h-[calc(100vh_-_65px)] px-l desktop:px-3xl">
    {#if selectedFilterType === FilterType.SELECTION}
        <FiltersSelection
            {handleSelectedFilter}
            {handleFormSubmissionAnalytics}
        />
    {:else if selectedFilterType === FilterType.SPORT}
        <SelectFilter
            bind:this={selectedFilterComponentRef}
            options={$filtersContext.defaultSportOptions}
            handleValidateSelection={() => {
                resetView();
            }}
            bind:values={$filtersContext.formValues.theme}
            bind:labels={$filtersContext.formLabels.theme}
            placeholder={'Rechercher des sports'}
            allLabel="Tous"
        />
    {:else if selectedFilterType === FilterType.DESTINATION}
        <SelectFilter
            bind:this={selectedFilterComponentRef}
            options={$filtersContext.defaultDestinationOptions}
            handleValidateSelection={() => {
                resetView();
            }}
            bind:values={$filtersContext.formValues.destination}
            bind:labels={$filtersContext.formLabels.destination}
            placeholder={'Rechercher des destinations'}
            allLabel="Toutes"
        />
    {:else if selectedFilterType === FilterType.PAX}
        <PaxFilter
            bind:this={selectedFilterComponentRef}
            handleValidateSelection={(value) => {
                $filtersContext.formValues.nbPax = value;
                $filtersContext.formLabels.nbPax = value;
                resetView();
            }}
        />
    {:else if selectedFilterType === FilterType.STARTDATE}
        <CalendarFilter
            bind:this={selectedFilterComponentRef}
            startDateValue={$filtersContext.formValues.startDate}
            endDateValue={$filtersContext.formValues.endDate}
            flexibility={$filtersContext.formValues.flexibility}
            handleValidateSelection={(value) => {
                $filtersContext.formValues.startDate = value.startDate;
                $filtersContext.formValues.endDate = value.endDate;
                $filtersContext.formLabels.startDate = value.startDate;
                $filtersContext.formLabels.endDate = value.endDate;
                $filtersContext.formValues.flexibility = value.flexibility;
                resetView();
            }}
        />
    {/if}
</section>
